import * as React from 'react';
// @ts-ignore
import { CopyToClipboard } from 'react-copy-to-clipboard';
import EventTracking from 'lib/EventTracking';
import Glyph from 'components/Glyph';
import Link from 'components/Link';
import Text from 'components/Text';

type Props = {
  shareToken: string;
  showToast: (text: string, kind: 'success' | 'error') => void;
  orgName: string;
  trackingPrefixProp: string;
};

const AdminUpgradePlanShareQuoteBanner = ({ shareToken, showToast, orgName, trackingPrefixProp }: Props) => {
  const componentTrackingPrefix = `${trackingPrefixProp}.admin_upgrade_share_quote_banner`;

  const track = (key: string) => {
    EventTracking.trackKey(`${componentTrackingPrefix}.${key}`);
  };

  const shareLink = `https://www.remind.com/modified_admin_upgrade/quote/${shareToken}`;
  const emailSubject = encodeURIComponent(`Remind Plan Quote for ${orgName}`);
  const emailBody = encodeURIComponent(
    `I've created a Remind plan quote for ${orgName}.

You can view the quote here: ${shareLink}

Teachers use Remind to reach students and parents with quick, simple text messages. Remind plans help administrators get everyone involved (rostering and analytics) and protect their communities (documentation and controls). Upgrading to a Remind plan also makes meaningful communication easier for everyone in the community (voice calls, longer messages, and more).

You can learn more about Remind plans at https://www.remind.com/plans`,
  );
  const emailLink = `mailto:?subject=${emailSubject}&body=${emailBody}`;

  return (
    <Text element="div" size="small" weight="semibold">
      <CopyToClipboard
        text={shareLink}
        onCopy={() => showToast('Link copied to clipboard!', 'success')}>
        <Link onClick={() => track('copy_link.click')}>
          <Glyph name="link" size="medium" solo />
          <span> Copy link to quote</span>
        </Link>
      </CopyToClipboard>
      <span>&nbsp;&nbsp;&nbsp;</span>
      <Link href={emailLink} onClick={() => track('email_link.click')}>
        <Glyph name="email-stroke" size="medium" solo />
        <span> Email quote</span>
      </Link>
    </Text>
  );
};

export default AdminUpgradePlanShareQuoteBanner;
